import {Component} from '@angular/core';

@Component({
    selector: 'clients-root',
    template: ` <member-direct-app></member-direct-app> `
})
export class AppComponent {}
